export default __webpack_public_path__ + "static/media/callback_elite.09fa7816.gif";